import { createEmptyMarketQuery, normalizeMarketQuery } from './marketQuery';

function routeValue(route, name) {
  return route && route.params ? route.params[name] : undefined;
}

export function marketQueryFromLegacyRoute(route = {}) {
  const type = routeValue(route, 'param1');
  const value = routeValue(route, 'param2');
  const query = createEmptyMarketQuery();

  if (!type) return { handled: true, restoreLast: true, query };
  if (type === 'platinum') query.selections = ['platinum'];
  else if (type === 'compatibility') {
    query.selections = ['compatibility'];
    if (route.query && route.query.currency) query.filters.currencies = [route.query.currency];
  }
  else if (type === 'last-ipos') query.selections = ['ipo'];
  else if (type === 'best-bullish-values' && value === 'last_week') query.selections = ['bullish_week'];
  else if (type === 'best-bullish-values' && value === 'last_month') query.selections = ['bullish_month'];
  else if (type === 'hot-values' && value === 'last_week') query.selections = ['hot_week'];
  else if (type === 'description' && value) query.description = value;
  else return { handled: false, restoreLast: false, query: null };

  return { handled: true, restoreLast: false, query: normalizeMarketQuery(query) };
}
